





































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Recruit from "../../store/entities/booking/recruit";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import Ajax from "../../lib/ajax";
import appconst from "../../lib/appconst";

TinymceInit.height = 300;

@Component({
    components: { Editor, }
})
export default class EditRecruit extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    recruit: Recruit = new Recruit();

    tinymceInit = TinymceInit;

    created() {}

    save() {
        (this.$refs.recruitForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "recruit/update",
                    data: this.recruit
                });
                (this.$refs.recruitForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.recruitForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.recruit = Util.extend(
                true,
                {},
                this.$store.state.recruit.editRecruit
            );
        }
    }

    recruitRule = {
        postName: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("PostName")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 128,
                message: this.L("NoMoreThenLength",undefined,this.L("PostName"),"128"),
                trigger: "blur"
            }
        ],
        responsibility: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Responsibility")),
                trigger: "blur"
            }
        ],
        requirement: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Requirement")),
                trigger: "blur"
            }
        ],
        salary: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Salary")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 64,
                message: this.L("NoMoreThenLength",undefined,this.L("Salary"),"64"),
                trigger: "blur"
            },
            {
                pattern: /^[\d.-]+$/,
                message: this.L("IncorrectFormat",undefined,this.L("Salary")),
                trigger: "blur"
            }
        ],
        jobAddress: [
            {
                type: 'string',
                max: 256,
                message: this.L("NoMoreThenLength",undefined,this.L("JobAddress"),"256"),
                trigger: "blur"
            }
        ],
        company: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("Company")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 128,
                message: this.L("NoMoreThenLength",undefined,this.L("Company"),"128"),
                trigger: "blur"
            }
        ],
        linkMan: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("LinkMan")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 128,
                message: this.L("NoMoreThenLength",undefined,this.L("LinkMan"),"128"),
                trigger: "blur"
            }
        ],
        telPhone: [
            {
                required: true,
                message: this.L("FieldIsRequired", undefined, this.L("TelPhone")),
                trigger: "blur"
            },
            {
                type: 'string',
                max: 128,
                message: this.L("NoMoreThenLength",undefined,this.L("TelPhone"),"128"),
                trigger: "blur"
            },
            {
                pattern: /^1[3456789]\d{9}$/,
                message: this.L("IncorrectFormat",undefined,this.L("TelPhone")),
                trigger: "blur"
            }
        ],
        address: [
            {
                type: 'string',
                max: 256,
                message: this.L("NoMoreThenLength",undefined,this.L("Address"),"256"),
                trigger: "blur"
            }
        ]
    };
}
